/**
 * Created by Jonas Wålekvist on 2018-08-16.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite} from "gsap";
import {MathHelper} from "../../../utils/MathHelper";
import {DungeonQuestGameAssets} from "../../DungeonQuestGameAssets";

export class SparkRect extends PIXI.Container {
    private _maskRect:PIXI.Rectangle;

    constructor(width:number, height:number) {
        super();
        this._maskRect = new PIXI.Rectangle(0, 0, width, height);
    }


    private createSpark():Timeline {
        const pos = MathHelper.randomPosInRect(this._maskRect);
        const spark = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.INTRO_LOGO_SPARK));
        spark.position.set(pos.x, pos.y);
        spark.anchor.set(0.5, 0.5);
        spark.hide();
        spark.blendMode = PIXI.BLEND_MODES.ADD;
        spark.alpha = 0.8;

        const scale = MathHelper.randomNumberFromInterval(0.2, 1);
        const flipX = Math.random() > 0.5 ? -1 : 1;
        const flipY = Math.random() > 0.5 ? -1 : 1;

        spark.scale.set(scale * flipX, scale * flipY);

        this.addChild(spark);
        return spark.getAnimationAutoShowHide(true, true);
    }

    public clearSparks() {
        this.removeChildren();
    }

    public getSparkAnimation(duration:number, level:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        const count = Math.floor(duration * 7 * (level + 1));
        const aSpark = this.createSpark();
        const totalDur = duration - aSpark.totalDuration();


        const startDelay = totalDur / count;
        for(let i:number = 0; i < count; i++) {
            tl.add(this.createSpark(), startDelay * i);
        }

        tl.add(() => this.clearSparks());

        return tl;

    }
}